import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import( '../h5/Home.vue'),
        meta: {
            title: 'Bonus Skin Chip!'
        }
    },
]

const router = new VueRouter({
    // mode: 'history',//去掉#号
    // base:'/',//该路径为服务器的存放路径
    routes
});

//    #vue history  必须配置
//     location /
//     {
//       root /www/wwwroot/snail.fk321.com;
//       try_files $uri $uri/ @router;
//       index index.html;
//     }
//     location @router{
//       rewrite ^.*$ /index.html last;
//     }

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

export default router
